// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3e_wO","colCheckbox":"styles_colCheckbox__3NzHa"};